import {createAction} from 'redux-actions';
import SMSChangeLang from "../../Networking/API/SMSChangeLang";

const constants = {};

constants.SMS_CHANGE_LANG_PENDING = 'app/iotg/SMS_CHANGE_LANG_PENDING';
constants.SMS_CHANGE_LANG_SUCCESS = 'app/iotg/SMS_CHANGE_LANG_SUCCESS';
constants.SMS_CHANGE_LANG_FAILURE = 'app/iotg/SMS_CHANGE_LANG_FAILURE';

const smsChangeLangPending = createAction(constants.SMS_CHANGE_LANG_PENDING);
const smsChangeLangSuccess = createAction(constants.SMS_CHANGE_LANG_SUCCESS);
const smsChangeLangFailure = createAction(constants.SMS_CHANGE_LANG_FAILURE);


const smsLangChange = (data) => async (dispatch) => {
    try {
        dispatch(smsChangeLangPending());
        const response = await SMSChangeLang({language: data});
        if (response) {
            dispatch(smsChangeLangSuccess(response.data))
        }

    } catch (e) {
        dispatch(smsChangeLangFailure());
        dispatch({
            type: 'alert/OPEN_FAILURE',
            payload: 'generalError'
        })
    }
}


const initialState = {
    loading: false,
    changedLang: false,
    errorMessageHandlerSms:false
};

export const smsActions = {
    smsLangChange
};

const SmsReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case constants.SMS_CHANGE_LANG_PENDING:
            return {...state, loading: true, changedLang: false, errorMessageHandlerSms:false};
        case constants.SMS_CHANGE_LANG_FAILURE:
            return {...state, loading: false, changedLang: false, errorMessageHandlerSms:true};
        case constants.SMS_CHANGE_LANG_SUCCESS:
            return {...state, loading: false, changedLang: true, errorMessageHandlerSms:false};
        default:
            return state;
    }

}

export default SmsReducer;

